<script lang="ts" setup>
  import { ref, onMounted } from 'vue'
  import HttpApi from '@/http/api'

  defineOptions({
    name: 'SallyActivityDialog'
  })

  const emit = defineEmits<{
    (e: 'close'): void
  }>()

  const qrcodeUrl = ref('')
  const qrcodeLoading = ref(true)

  const fetchQrcode = async () => {
    try {
      const res: any = await HttpApi.shareInfo({
        link: '/pagesMarket/sallyBirthday/index?enterFrom=pc_scan_code',
        biz: 'activity',
        uniqueId: '/pagesMarket/sallyBirthday/index?enterFrom=pc_scan_code'
      })
      if (res.code === 200 && res.data?.wxQrCodeBase64) {
        qrcodeUrl.value = `${res.data.wxQrCodeBase64}`
      }
    } catch (e) {
      // 请求失败静默处理
    } finally {
      qrcodeLoading.value = false
    }
  }

  onMounted(() => {
    fetchQrcode()
  })

  const handleClose = () => {
    emit('close')
  }

  const handleConfirm = () => {
    emit('close')
  }
</script>

<template>
  <Teleport to="body">
    <div class="sally-dialog-overlay" @click.self="handleClose">
      <div class="sally-dialog-wrapper">
        <div class="sally-dialog-content">
          <div class="sally-dialog-header">
            <div class="sally-dialog-bg-vector"></div>
            <img
              class="sally-dialog-character"
              src="https://static.zaohaowu.com/image-mcp-static/sally-dialog-character_826b099a30a5415b626b0626a1065b6c.png"
              alt=""
            />
            <div class="sally-dialog-qrcode-wrapper">
              <div v-if="qrcodeLoading" class="sally-dialog-qrcode sally-dialog-qrcode-loading">
                <span class="sally-dialog-spinner"></span>
              </div>
              <img v-else-if="qrcodeUrl" class="sally-dialog-qrcode" :src="qrcodeUrl" alt="" />
              <div class="sally-dialog-mp-info">
                <img
                  class="sally-dialog-scanner"
                  src="https://static.zaohaowu.com/image-mcp-static/sally-dialog-scanner_6afe46527f1d60c533bf8dd8eff382b0.svg"
                  alt=""
                />
                <span class="sally-dialog-mp-name">AI 造好物-微信小程序</span>
              </div>
            </div>
          </div>
          <div class="sally-dialog-body">
            <p class="sally-dialog-text">
              <span>当前活动仅在小程序上线，</span>
              <br />
              <span>请</span>
              <span class="sally-dialog-text-green">微信扫码 ⬆️</span>
              <span>，前往小程序查看～</span>
            </p>
            <button class="sally-dialog-btn" @click="handleConfirm">好的～</button>
          </div>
        </div>
        <div class="sally-dialog-close" @click="handleClose">
          <span class="hitems-close"></span>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<style scoped lang="stylus">
  @import './index.styl'
</style>
